export const BASE_URL = "https://api.departsante.com"; //DEV

